import { pathWithoutWorkspace, WORKSPACE_QUERY, workspaceSlugFromPath } from "../../shared/workspace-path";
import { isTenantHost } from "./tenant";

/** The workspace this tab is in, read off the address. Null on the app's own pages. */
export function currentWorkspaceSlug(): string | null {
  if (typeof window === "undefined") return null;
  if (isTenantHost(window.location.hostname)) return null;
  return workspaceSlugFromPath(window.location.pathname);
}

/** An in-app path with this tab's workspace on the front, for a raw link. */
export function appPath(path: string): string {
  const slug = currentWorkspaceSlug();
  return slug ? `/${slug}${path}` : path;
}

/** Where a workspace's app lives, keeping the page this tab is on. */
export function workspaceHome(slug: string, keepPage = false): string {
  const rest = keepPage && typeof window !== "undefined" ? pathWithoutWorkspace(window.location.pathname) + window.location.search : "/";
  return `/${slug}${rest === "/" ? "/" : rest}`;
}

/** The query a WebSocket URL carries, since it cannot send the header. */
export function wsQuery(): string {
  const slug = currentWorkspaceSlug();
  return slug ? `?${WORKSPACE_QUERY}=${encodeURIComponent(slug)}` : "";
}
